var render = function (_h,_vm) {var _c=_vm._c;return _c('footer',{staticClass:"the-footer flex-wrap justify-between",class:_vm.classes},[_c('div',{staticClass:"footer-build"},[_c('p',{class:_vm.build_version},[_vm._v("Build "+_vm._s(_vm.build_version))])])])}
var staticRenderFns = []

export { render, staticRenderFns }